<template>
  <v-container fill-height fluid>
    <v-flex sm10 offset-sm1 v-if="formload" text-md-center pt-5>
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
    </v-flex>
    <v-flex v-else sm10 offset-sm1 pt-5>
      <v-alert :type="banner" value="true" class="print">{{banner_text}}</v-alert>
      <v-card class="elevation-5" id="forprint">
        <v-card-text>
          <v-flex>
            <v-layout row wrap>
              <v-flex class="rowmid" xs8 sm7 offset-sm1>
                <v-list>
                  <v-list-tile>
                    <img class="logo_trawling_web text-xs-left logo" width="200px" :src="logo">
                  </v-list-tile>
                  <v-list-tile-title class="subheading order_info">
                    <span style="font-weight: bold;" class="title">{{ 'order.order_num' | t }}</span>
                    {{ order.id }}
                  </v-list-tile-title>
                  <v-list-tile-title class="mt-1 subheading order_info">
                    <span style="font-weight: bold;" class="title">{{ 'order.billing_date' | t }}</span>
                    {{ order.billing_date | date }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="mt-3 title_company">{{ order.my_company_name }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>{{ order.my_company_cif }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>{{ order.my_company_phone }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    v-for="address in my_company_address"
                    v-bind:key="address"
                  >{{ address }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>{{ order.my_company_city }} {{ order.my_company_postal_code }}</v-list-tile-sub-title>
                </v-list>
              </v-flex>
              <v-flex xs3 sm3 md3 offset-sm1 offset-md1 class="mt-1 text-xs-right">
                <v-list>
                  <v-list-tile-sub-title
                    class="mt-5 subtitul_pers"
                  >{{ order.firstname }} {{ order.lastname }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    v-if="order.company !== ''"
                    class="subtitul_pers"
                  >{{ order.company }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title class="subtitul_pers">{{ order.id_card }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title class="subtitul_pers">{{ order.address }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title
                    class="subtitul_pers"
                  >{{ order.postal_code }} ({{ order.city }}), {{ order.country_name }}</v-list-tile-sub-title>
                </v-list>
                <v-list>
                  <v-list-tile-sub-title>
                    <v-btn flat outline large @click="printnow" class="print" :loading="printload">
                      <v-icon large class="mr-2 mb-1">print</v-icon>
                      {{ 'order.print' | t }}
                    </v-btn>
                  </v-list-tile-sub-title>
                </v-list>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs10 offset-xs1 class="mt-5">
                <v-data-table
                  :headers="headers"
                  hide-actions
                  :items="ordersar"
                  class="elevation-0 table"
                >
                  <template slot="items" slot-scope="props">
                    <tr class="grey lighten-5">
                      <td class="text-xs-left prod_info">{{ props.item.type }}</td>
                      <td class="text-xs-left prod_info">{{ props.item.name }}</td>
                      <td class="text-xs-left prod_info">{{ props.item.quantity }}</td>
                      <td class="text-xs-left prod_info">{{ props.item.discount }} %</td>
                      <td class="text-xs-left prod_info">{{ props.item.price | currency }} &euro;</td>
                      <td
                        class="text-xs-left prod_info"
                      >{{ props.item.base_price | currency }} &euro;</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-card-text class="py-3">
          <v-layout row wrap>
            <v-flex offset-md1>
              <v-list-tile-title
                v-if="order.billing_text !== ''"
                class="text-xs-left"
              >{{ order.billing_text }}</v-list-tile-title>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text class="py-2">
          <v-layout row wrap class="ly_preus">
            <v-flex md2 offset-md7 class="ly_preu_info">
              <v-list-tile-title
                class="title text-xs-left mb-2 subtitul preu_info"
              >{{ 'order.base_price' | t }}</v-list-tile-title>
              <v-list-tile-title
                class="title text-xs-left mb-2 subtitul preu_info"
              >{{ 'order.taxes' | t }}</v-list-tile-title>
              <v-list-tile-title
                class="title text-xs-left mb-2 subtitul preu_info"
              >{{ 'order.total_price' | t }}</v-list-tile-title>
            </v-flex>
            <v-flex md2 class="ly_valors_preu">
              <v-list-tile-title
                class="title text-xs-right mb-2 subtitul valors_preu"
              >{{ order.base_price | currency }} &euro;</v-list-tile-title>
              <v-list-tile-title
                class="title text-xs-right mb-2 subtitul valors_preu"
              >{{ order.taxes }} &#37;</v-list-tile-title>
              <v-list-tile-title
                class="title text-xs-right mb-2 subtitul valors_preu"
              >{{ order.total_price | currency }} &euro;</v-list-tile-title>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ly_info_company">
            <v-flex xs8 sm8 md9 offset-md2 offset-sm2 offset-xs3>
              <div class="text-xs-left subtitul_company">{{order.my_company_register}}</div>
              <div class="text-xs-left subtitul_company">{{order.my_company_description}}</div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import logo from "@/assets/trawling-web-logo-versio-web.png";

export default {
  data() {
    return {
      formload: true,
      banner: "warning",
      banner_text: "Order is pending",
      ivacalculat: 0,
      ordersar: [],
      order: {
        id: 1801728,
        tipo: 0,
        user: 38,
        consumer: 23,
        product: 3,
        product_set: 2,
        emission_date: "1985-07-06",
        billing_date: "1985-07-06",
        firstname: "Josep",
        lastname: "Subils",
        company: "Anpro21",
        address: "Address",
        phone: "123123123",
        postal_code: 17002,
        city: "Girona",
        country_name: "Luxembourg",
        id_card: "26375245",
        billing_text: "",
        product_name: "Pack 5.000",
        product_description: "Basic 5.000",
        product_type: "Basic",
        my_company_name: "ASSESSORS NOUS PROFESSIONALS SXXI, S.L.",
        my_company_address:
          "Parc Científic i Tecnològic de la UdG - Edifici Narcís Monturiol - C/ Emili Grahit, 91",
        my_company_postal_code: "17003",
        my_company_city: "Girona",
        my_company_country: "España",
        my_company_phone: "+34 972 18 32 22",
        my_company_cif: "B17850553",
        my_company_register:
          "Trawlingweb és una marca de Assessors Nous Professionals S.XXI, S.L. Sociedad inscrita en el registro mercantil de Girona Tomo 2290, Libro 0, Folio 125, Hoja GI 38569",
        my_company_web: "https://www.trawlingweb.com",
        my_company_description:
          "Según la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de datos de Carácter Personal, le informamos que los datos forman parte de un fichero propiedad de Assessors Nous Professionals S.XXI S.L. con la finalidad de gestión y facturación de los servicios encargados. Al mismo tiempo, consiente la utilización de sus datos para facilitarle información comercial de nuestros productos y servicios o de cualquiera de las sociedades en las que nuestra empresa participe. Le informamos que puede ejercer los derechos de acceso, rectificación, cancelación u oposición mediante carta certificada a: Assessors Nous Professionals S.XXI S.L. Parc Científic i Tecnològic de la UdG - Edifici Narcís Monturiol - C/ Emili Grahit, 91, 17003 Girona (España)",
        price: 10000,
        discount: 0,
        discount_amount: 0,
        taxes: 15,
        taxes_amount: 1500,
        vat_valid: 0,
        base_price: 10000,
        total_price: 11500,
        status: 2,
        transaction_error: ""
      },
      my_company_address: [""],
      valid: false,
      logo,
      headers: [
        { text: "Product type", sortable: false },
        { text: "Pack name", sortable: false },
        { text: "Quantity", sortable: false },
        { text: "Discount", sortable: false },
        { text: "Unitary price", sortable: false },
        { text: "Price", sortable: false }
      ],
      printload: false
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.$http
      .get(`${this.getServer}/orders/${this.id}`, this.getTokenHeader)
      .then(data => {
        if (data.data !== undefined) {
          this.order = data.data;
          this.ordersar = [
            {
              type: data.data.product_type,
              name: data.data.product_name,
              quantity: 1,
              discount: data.data.discount,
              price: data.data.price,
              base_price: data.data.base_price
            }
          ];

          switch (this.order.status) {
            case 2:
              this.banner = "success";
              this.banner_text = "Order transfer is OK";
              break;
            case 0:
              this.banner = "warning";
              this.banner_text = "Order transfer is pending";
              break;
            default:
              this.banner = "error";
              this.banner_text = "Order transfer is failed";
          }
          const superaddress = data.data.my_company_address.split(" - ");
          if (superaddress.length > 2) this.my_company_address = superaddress;
          this.formload = false;
        }
      })
      .catch(() => {
        this.$router.push({ path: "/home" });
      });
  },
  computed: {
    ...mapGetters(["getServer", "getTokenHeader"])
  },
  methods: {
    ...mapActions(["rmKey"]),
    printnow() {
      this.printload = true;
      this.$htmlToPaper("forprint");
      this.printload = false;
    }
  }
};
</script>

<style scoped>
.ly_info_company {
  display: none;
}
</style>